module.exports = __webpack_public_path__ + "img/php-icon.75c2ab67.png";